import React from 'react';
import { useRecoilValue } from 'recoil';
import { isDevSelector } from '../../states/auth';

export default function Dev({ children }) {
  const isDev = useRecoilValue(isDevSelector);
  if (!isDev) return <></>;
  return children;
}
